export const SENTRY_DSN =
  'https://1a044e4a0611f8c39e1f4a3b12adadf7@o366774.ingest.us.sentry.io/4509627724267520';

export const SENTRY_TUNNEL = 'tu-tu-nail';
